@if (selected$ | async; as selected) {
  <!-- Single edit needs the full dialog width for its two-column desktop form. Bulk edit
       is intentionally narrower and stacked, so it owns a compact shell instead of
       rendering a narrow form inside the wide single-edit shell. -->
  <app-ui-dialog-shell
    [title]="selected.length === 1 ? 'Edit transaction' : 'Edit ' + selected.length + ' transactions'"
    [shellClass]="selected.length === 1 ? 'w-[calc(100dvw-2rem)]' : 'w-[calc(100dvw-2rem)] max-w-lg'"
    [ariaDescribedBy]="selected.length > 1 ? summaryId : null"
  >
    @if (selected.length > 1) {
      <p class="edit-transaction-summary text-text-muted" [id]="summaryId">
        Choose the fields to update. Empty fields stay unchanged.
      </p>
    }

    <app-edit-transactions
      [transactions]="selected"
      (transactionUpdatedEvent)="transactionListEvent($event)"
    />
  </app-ui-dialog-shell>
}
